import { STEPS } from "./constants";

type StepValidation = {
  fields?: string | string[];
  isComplete: (res: any) => boolean;
};

export const STEP_CONFIG: Record<number, StepValidation> = {
  1: {
    fields: ["title", "status", "placeId", "translations" , "cityId"],
    isComplete: (r) => !!r?.title && !!r?.translations?.length,
  },
  2: { isComplete: (r) => !!r?.pickupDropoff },
  3: { fields: "itineraries", isComplete: (r) => !!r?.itineraries?.length },
  4: { fields: "schedules", isComplete: (r) => !!r?.schedules?.length },
  5: { fields: "options", isComplete: (r) => !!r?.options?.length },
  6: {
    fields: "paymentMethods",
    isComplete: (r) => !!r?.paymentMethods?.length,
  },
  7: { fields: "gallery", isComplete: (r) => !!r?.gallery?.length },
  8: { isComplete: () => true },
};

export const validateStep = async (
  step: number,
  trigger: (fields?: any) => Promise<boolean>,
): Promise<boolean> => {
  const fields = STEP_CONFIG[step]?.fields;
  return fields ? trigger(fields) : true;
};

export const deriveFurthestStep = (res: any): number => {
  let furthest = 1;
  for (let s = 1; s <= STEPS.length; s++) {
    if (STEP_CONFIG[s]?.isComplete(res)) furthest = s;
  }
  return furthest;
};
